import axios from "axios";
import React from "react";

interface IStatus {
  id: number;
  name: string;
}

export default function useStatuses(): [Map<number, string>, boolean] {
  const [statuses, setStatuses] = React.useState<Map<number, string>>(
    new Map()
  );
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    setLoading(true);
    axios
      .get<IStatus[]>("/status/")
      .then((response) => {
        setStatuses(new Map(response.data.map((x) => [x.id, x.name])));
        setLoading(false);
      })
      .catch((error) => { console.error(error); setLoading(false); });
  }, []);

  return [statuses, loading];
}
